<template>
  <div class="logo-animation" ref="logoAnimation">
    <div class="logo-animation-container" ref="logoAnimationContainer">
      <video class="video-1" autoplay ref="video1">
        <source src="../assets/video/layer3_720p_1.webm" type="video/webm; codecs=vp9">
        <source src="/statics/layer3_hevc.mov" type="video/quicktime">
      </video>
      <video class="video-2" autoplay ref="video2">
        <source src="../assets/video/layer2_720p_1.webm" type="video/webm; codecs=vp9">
        <source src="/statics/layer2_hevc.mov" type="video/quicktime">
      </video>
      <video class="video-3" autoplay ref="video3">
        <source src="../assets/video/layer1_720p_1.webm" type="video/webm; codecs=vp9">
        <source src="/statics/layer1_hevc.mov" type="video/quicktime">
      </video>

    </div>
  </div>
</template>

<script>
  export default {
    name: "LogoAnimation",

    data() {
      return {
        stopAnimationCallbacks: {}
      }
    },

    methods: {
      animateLogo() {
        this.$refs.video1.muted = true;
        this.$refs.video2.muted = true;
        this.$refs.video3.muted = true;
        this.$refs.video1.play();
        this.$refs.video2.play();
        this.$refs.video3.play();
      },
      stopAnimation(videoNo) {
        if (videoNo && this.$refs[videoNo].currentTime >= 2) { //after 2 seconds
          this.$refs[videoNo].pause();
          this.$refs[videoNo].removeEventListener('timeupdate', this.stopAnimationCallbacks[videoNo]);
        }
      },
      pauseLogo(after = 1500) {
        this.stopAnimationCallbacks = {
          'video1': this.stopAnimation.bind(null, "video1"),
          'video2': this.stopAnimation.bind(null, "video2"),
          'video3': this.stopAnimation.bind(null, "video3"),
        };
        this.$refs.video1.addEventListener("timeupdate", this.stopAnimationCallbacks['video1']);
        this.$refs.video2.addEventListener("timeupdate", this.stopAnimationCallbacks['video2']);
        this.$refs.video3.addEventListener("timeupdate", this.stopAnimationCallbacks['video3']);
      },
      cssParallax() {
        document.documentElement.addEventListener('mousemove', event => {

          let cx = Math.ceil(document.documentElement.clientWidth / 2.0);
          let cy = Math.ceil(document.documentElement.clientHeight / 2.0);
          let dx = event.clientX - cx;
          let dy = event.clientY - cy;

          let tiltx = (dy / cy);
          let tilty = -(dx / cx);
          let radius = Math.sqrt(Math.pow(tiltx, 2) + Math.pow(tilty, 2));
          let degree = (radius * 5);

          this.$refs.logoAnimation.style.transform = 'rotate3d(' + tiltx + ', ' + tilty + ', 0, ' + degree + 'deg)';
          this.$refs.logoAnimationContainer.style.transform = 'rotate3d(' + tiltx + ', ' + tilty + ', 0, ' + degree + 'deg)';
        });
      },

      cssParallaxMobile(e) {
        let transform =
          "rotateX(" + e.beta * 0.3 + "deg) " +
          "rotateY(" + ( -e.gamma * 0.3 ) + "deg)"
        ""
        ;

        this.$refs.logoAnimationContainer.style.WebkitTransform = transform;
        this.$refs.logoAnimationContainer.style.MozTransform = transform;
      },
    },

    mounted() {
      if (window.visualViewport.width < 992) {
        window.addEventListener("deviceorientation", this.cssParallaxMobile)
      } else {
        setTimeout(this.cssParallax, 4000);
      }
    }
  }
</script>

<style lang="scss">
  @import "LogoAnimation";
</style>
